import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"
import { interpolateRgb } from "d3-interpolate";
import { color } from "d3-color";
import LiquidFillGauge from "react-liquid-gauge";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Helmet } from 'react-helmet';
import { Tooltip, Typography } from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';
import DatagridComp from "../DatagridComp";
import { GetuserDatavalue } from "../../../Commonalert/commonalert";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import Loader from "../CommonLoader";
import { Container, Grid, Box } from '@mui/material';
import UserActivityTracker from "../../../hooks/userActivityTracker";
import WarningCount from "../Asset/esocardicon/SchemaDetail/WarningCount.svg";
import ErrorCount from "../Asset/esocardicon/SchemaDetail/ErrorCount.svg";
import Chart from "react-apexcharts";
import Commoncard from "../Commoncard";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import Select from "react-select";
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import { removeDuplicateDate } from './../Commonfun';

export default function BacklinksReport(props) {

  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const [autoheightval, SetAutoheightval] = useState(true)
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [tableLoading, setTableLoading] = useState(true);
  const [summaryData, setSummaryData] = useState({
    "total_links": 0,
    "link_quality": {
      "follow": 0,
      "nofollow": 0
    },
    "link_visual_type": {
      "text": 0,
      "image": 0
    },
    "authority_distribution": {},
    "historical_backlink_trend": [],
    "top_impact_links": []
  });
  const [aiSuggestions, setAiSuggestions] = useState({});
  const [selectedSuggesRow, setSelectedSuggesRow] = useState({
    suggesSid: null,
    suggesId: null,
    openModel: false
  });
  const [selectedTargetKeyword, setSelectedTargetKeyword] = useState('');
  const navigate = useNavigate();

  const apihandleClose = () => {
    setapiOpen(false);
  };
  const [OpenModalJob, SetOpenModalJob] = useState(false);
  const [completedate, Setcompletedate] = useState([]);
  const [Selectval, setSelectval] = useState("");

  const [dEngineoption, SetdEngineoption] = useState({
    completed_at: "Select Date",
    id: "Select Date",
  });

  const [validationFiter, SetvalidationFiter] = useState("");
  const [jobvalsel, SetJobvalsel] = useState("");

  const [FollowType, SetFollowType] = useState({
    value: "all",
    label: "All",
  });

  const [followTypeErr, SetFollowTypeErr] = useState("");
  const CloseModalJobTrigger = () => {
    SetOpenModalJob(false);
    SetvalidationFiter("");
    SetFollowTypeErr("");
  };

  const OpenModalJobTrigger = () => {
    SetOpenModalJob(true);
  };

  const handleAiReadinessClick = async () => {
    // if (!url) {
    //   toast.error("No AI suggestion URL available", {
    //     position: "top-center",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "light",
    //   });
    //   return;
    // }

    if (!ApiToken) {
      toast.error("Authorization token is missing or invalid. Please log in again.", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    setLoading(true);

    const data = {
      backlink_id: selectedSuggesRow.suggesId,
      user_domain_id: esodata.domaindata.value.header_selected,
      target_keyword: selectedTargetKeyword
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_report/`, data, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      });

      if (response?.status === 401) {
        toast.error("Session expired. Please log in again.", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/login"); // Redirect to login page
        return;
      }

      if (response?.data?.suggestions) {
        setAiSuggestions((prev) => ({
          ...prev,
          [selectedSuggesRow.suggesSid]: response.data.suggestions,
        }));
        closeSuggestion();
        toast.success("AI Suggestion loaded", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        toast.error("No suggestion found in response", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } catch (error) {
      setapiOpen(true);
      setapierrorMsg(error?.response?.data?.error)
      console.error("Error fetching AI suggestion:", error);
    } finally {
      setLoading(false);
    }
  }

  const openSuggestion = (sid, id) => {
    console.log('sid, id', sid, id);
    setSelectedSuggesRow({
      suggesSid: sid,
      suggesId: id,
      openModel: true
    });
  }

  const closeSuggestion = () => {
    setSelectedSuggesRow({
      suggesSid: selectedSuggesRow.suggesSid,
      suggesId: selectedSuggesRow.suggesId,
      openModel: false
    });
    setSelectedTargetKeyword('');
  }
  const GetReportJobDates = async () => {
    setLoading(true);

    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?user_domain_id=${esodata.domaindata.value.header_selected}&job_type=backlinks`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (
          error?.response?.status == 599 ||
          error?.response?.status == 400 ||
          error?.response?.status == 500
        ) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error);
        } else if (
          error?.code == "ERR_NETWORK" ||
          error?.response?.status == 404
        ) {
          navigate("/errorpages");
        }
      });

      setLoading(false);

      if (datavalue?.data?.jobs?.length > 0) {
        const uniqueByCompletedAt = removeDuplicateDate(datavalue.data.jobs);

        Setcompletedate(uniqueByCompletedAt);
        SetdEngineoption(uniqueByCompletedAt[0]);
        setSelectval(uniqueByCompletedAt[0]);
      }
    } catch (err) {
      setLoading(false);
    }
  };


  const columns = [

    {
      field: "referring_page",
      headerName: "Referring Page/Title",
      minWidth: 400,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      description: "Referring page's URL or referring page's title.",
      renderCell: (cardData) => {
        let baseUrl = cardData?.row?.referring_page.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData?.row?.referring_page.split("/").slice(3).join("/");
        return (
          <div classname="link-dt-left"><span style={{ color: "hsl(38.3deg 100% 56.08%)" }}>{cardData?.row?.title}</span>
            <br />
            <Tooltip title={cardData.row.referring_page}>
              <div className="prefered_url_external02">
                <a target="_blank" href={cardData?.row?.referring_page} style={{ display: 'flex', flexDirection: 'column' }}>
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }} >{remaining}</span>
                </a>
              </div>
            </Tooltip>
          </div>
        );
      },
    },

    // {
    //   field: "da",
    //   headerName: "DA",
    //   minWidth: 80,
    //   flex: 1,
    //   headerAlign: 'center',
    //   align: 'center',
    //   sortable: false,
    //   description: "Domain InLink Rank of the target's root domain.",
    // },
    {
      field: "da",
      headerName: "DA",
      minWidth: 100,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "Domain InLink Rank of the target's root domain.",
      renderCell: (cardData) => {
        var sr = cardData.row.da;
        var s = sr
        return (
          <LiquidFillGauge
            style={{ margin: "0 auto" }}
            width={44}
            height={44}
            value={s}
            percent=""
            textSize={1}
            textOffsetX={0}
            textOffsetY={0}
            riseAnimation
            waveAnimation
            waveFrequency={2}
            waveAmplitude={1}
            gradient
            gradientStops={gradientStops}
            circleStyle={{
              fill: '#0b2033',
            }}
            waveStyle={{
              fill: fillColor,
            }}
            textStyle={{
              fill: color("#0b2033").toString(),
              fontFamily: "Poppins, sans-serif",
            }}
            waveTextStyle={{
              fill: color("#0b2033").toString(),
              fontFamily: "Poppins, sans-serif",
            }}
          />
        );
      },
    },
    // {
    //   field: "pa",
    //   headerName: "PA",
    //   minWidth: 80,
    //   flex: 1,
    //   headerAlign: 'center',
    //   align: 'center',
    //   sortable: false,
    //   description: "InLink rank of the target URL.",
    // },
    {
      field: "pa",
      headerName: "PA",
      minWidth: 100,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "InLink rank of the target URL.",
      renderCell: (cardData) => {
        var sr = cardData.row.pa;
        var s = sr
        return (
          <LiquidFillGauge
            style={{ margin: "0 auto" }}
            width={44}
            height={44}
            value={s}
            percent=""
            textSize={1}
            textOffsetX={0}
            textOffsetY={0}
            riseAnimation
            waveAnimation
            waveFrequency={2}
            waveAmplitude={1}
            gradient
            gradientStops={gradientStops}
            circleStyle={{
              fill: "#0b2033",
            }}
            waveStyle={{
              fill: fillColor,
            }}
            textStyle={{
              fill: color("#0b2033").toString(),
            }}
            waveTextStyle={{
              fill: color("#0b2033").toString(),
            }}
          />
        );
      },
    },
    {
      field: "anchor",
      headerName: "Anchor/Target Page",
      minWidth: 400,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      description: "Link anchor text for text links/Destination page's URL.",
      renderCell: (cardData) => {
        let baseUrl = cardData?.row?.target_page.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData?.row?.target_page.split("/").slice(3).join("/");
        let baseUrl1 = cardData?.row?.anchor?.split("/").slice(0, 3).join("/") || '';
        let remaining1 = cardData?.row?.anchor?.split("/").slice(3).join("/") || '';
        return (
          <div classname="link-dt-left"><span style={{ color: "hsl(38.3deg 100% 56.08%)" }}>
            {baseUrl1}<br />
            {remaining1}
          </span>
            <br />
            <Tooltip title={cardData.row.target_page}>
              <div className="prefered_url_external02">
                <a target="_blank" href={cardData?.row?.target_page} style={{ display: 'flex', flexDirection: 'column' }}>
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }} >{remaining}</span>
                </a>
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "suggested_anchors",
      headerName: "AI Suggestion",
      description: "SEO-optimized anchor text ideas generated by AI to improve your ranking for target keywords.",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableClickEventBubbling: true,
      renderCell: (params) => {
        const rowId = params.row.sid;
        const suggestion = aiSuggestions[`${rowId}`];
        if (params?.row?.suggested_anchors.length > 0 || suggestion) {
          return (
            <ul style={{ textAlign: 'left' }}>
              {(suggestion ?? params?.row?.suggested_anchors).map(item => {
                return <li>{item}</li>
              })}
            </ul>
          );
        }

        return (
          <button
            // onClick={() => handleAiReadinessClick(`${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_report/`, data, rowId)}
            onClick={() => openSuggestion(params.row.sid, params.row.id)}
            style={{
              padding: "8px 16px",
              backgroundColor: "#ff601f",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500"
            }}
          >
            Suggestion
          </button>
        );
      }
    },
    {
      field: "link_type",
      headerName: "Link Type",
      minWidth: 100,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      description: 'Type of backlink.',
    },
    {
      field: "nofollow",
      headerName: "Follow/No Follow",
      minWidth: 100,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      description: 'Number of backlinks marked as nofollow and number of backlinks not marked as nofollow.',
    },
    {
      field: "first_seen",
      headerName: "First Seen",
      minWidth: 100,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      description: 'The date when the backlink was added to the index or the date when our crawlers last visited the referring page.',
    },
    {
      field: "last_visited",
      headerName: "Last Visited",
      minWidth: 100,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      description: "The date when the backlink was added to the index or the date when our crawlers last visited the referring page.",
    },

  ];

  const rows = cardData ?? [];
  const LoadData = async (tableid = "", selectedJobId = "", selectedFollowType = "") => {
    var JobId = "";

    if (selectedJobId) {
      JobId = selectedJobId;
    } else if (Selectval && Selectval.value) {
      JobId = Selectval.value;
    } else if (props.RankJob) {
      if (props.RankJob.value) {
        JobId = props.RankJob.value;
      }
    }

    const FollowTypeValue = selectedFollowType
      ? selectedFollowType
      : FollowType?.value || "all";

    setLoading(true);
    setTableLoading(true);

    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_report/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${JobId}&follow_type=${FollowTypeValue}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (
          error?.response?.status == 599 ||
          error?.response?.status == 400 ||
          error?.response?.status == 500
        ) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error);
        } else if (
          error?.code == "ERR_NETWORK" ||
          error?.response?.status == 404
        ) {
          navigate("/errorpages");
        }
      });

      if (datavalue?.data) {
        props.setjobDate(moment(datavalue.data.job_date).format("MMMM DD,YYYY HH:mm"));

        setSummaryData({
          total_links: datavalue?.data?.charts?.summary?.total_links || 0,
          link_quality: {
            follow: datavalue?.data?.charts?.link_quality?.follow || 0,
            nofollow: datavalue?.data?.charts?.link_quality?.nofollow || 0,
          },
          link_visual_type: {
            text: datavalue?.data?.charts?.link_visual_type?.text || 0,
            image: datavalue?.data?.charts?.link_visual_type?.image || 0,
          },
          authority_distribution: datavalue?.data?.charts?.authority_distribution || {},
          historical_backlink_trend: datavalue?.data?.charts?.historical_backlink_trend || [],
          top_impact_links: datavalue?.data?.charts?.summary?.top_impact_links || [],
        });
      }

      if (datavalue?.data?.report) {
        var TableArray = datavalue.data.report;

        if (TableArray && TableArray.length > 0) {
          const newData = TableArray.map((obj, index) => {
            return { ...obj, sid: index + 1 };
          });
          setCardData(newData);
          SetAutoheightval(false);
        } else {
          setCardData("");
          SetAutoheightval(true);
        }
      }
    } catch (err) {
      console.log(err);
    }

    setTableLoading(false);
    setLoading(false);
  };
  const TriggerFilter = () => {
    let hasError = 1;

    if (Selectval === "" || !Selectval?.value) {
      SetvalidationFiter("Please select the completed date");
      hasError = 2;
    } else {
      SetvalidationFiter("");
    }

    if (FollowType === "" || !FollowType?.value) {
      SetFollowTypeErr("Please select the follow type");
      hasError = 2;
    } else {
      SetFollowTypeErr("");
    }

    if (hasError === 2) {
      return false;
    }

    const JobId = Selectval.value;
    const FollowTypeValue = FollowType.value;

    SetJobvalsel(JobId);
    LoadData("", JobId, FollowTypeValue);

    SetOpenModalJob(false);
  };
  const handleFilterReset = () => {
    SetFollowType({
      value: "all",
      label: "All",
    });

    setSelectval("");

    SetdEngineoption({
      completed_at: "Select Date",
      id: "Select Date",
    });

    SetvalidationFiter("");
    SetFollowTypeErr("");
    SetJobvalsel("");

    LoadData("", "", "all");
    SetOpenModalJob(false);
  };

  useEffect(() => {
    GetuserDatavalue(setOpenCommonAlerts, ApiToken, navigate);
    LoadData();
    GetReportJobDates();
  }, []);

  // useEffect(() => {
  //   if (props.FilterButtonTriggered === true) {
  //     LoadData()
  //     props.SetFilterButtonTriggered(false)
  //     props.closeModal()
  //   }

  // }, [props])

  var startColor = "#6495ed";
  var endColor = "#dc143c";
  const interpolate = interpolateRgb(startColor, endColor);
  const fillColor = "rgb(255,174,31)";
  const textfillColor = "rgb(255,255,255)";
  const gradientStops = [
    {
      key: "0%",
      stopColor: color(fillColor).darker(0.5).toString(),
      stopOpacity: 1,
      offset: "0%",
    },
    {
      key: "50%",
      stopColor: fillColor,
      stopOpacity: 0.75,
      offset: "50%",
    },
    {
      key: "100%",
      stopColor: color(fillColor).brighter(0.5).toString(),
      stopOpacity: 0.5,
      offset: "100%",
    },
  ];

  const handleModelPopUp = () => {
    OpenModalJobTrigger();
  };

  const handleDownlodingCSV = () => {
    props.csvdown();
  }

  const handleDownlodingPDF = () => {
    props.pdfdown();
  }

  const cardDatas = [
    {
      value: summaryData.link_quality.follow || 0,
      title: "Follow",
      // badge: "SEO",
      iconSrc: ErrorCount,
      iconColor: 1,
      bgColor: 1,
    },
    {
      value: summaryData.link_quality.nofollow || 0,
      title: "UnFollow",
      // badge: "TRAFFIC",
      iconSrc: WarningCount,
      iconColor: 2,
      bgColor: 2,
    },
    {
      value: summaryData.link_visual_type.image || 0,
      title: "Visual Image",
      // badge: "SEO",
      iconSrc: ErrorCount,
      iconColor: 3,
      bgColor: 3,
    },
    {
      value: summaryData.link_visual_type.text || 0,
      title: "Visual Text",
      // badge: "TRAFFIC",
      iconSrc: WarningCount,
      iconColor: 4,
      bgColor: 4,
    },
    {
      value: summaryData.total_links || 0,
      title: "Total Links",
      // badge: "TRAFFIC",
      iconSrc: WarningCount,
      iconColor: 1,
      bgColor: 1,
    }
  ];

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false }
    },
    plotOptions: {
      bar: {
        horizontal: true, // better for long URLs
        barHeight: "60%"
      }
    },
    xaxis: {
      categories: summaryData.top_impact_links?.map(item =>
        item.title.length > 40 ? item.title.slice(0, 40) + "..." : item.title
      ) || [],
      labels: {
        show: false   // 👈 hides numbers/text on x-axis
      },
      axisBorder: {
        show: false   // optional: remove axis line
      },
      axisTicks: {
        show: false   // optional: remove ticks
      }
    },
    yaxis: {
      labels: {
        maxWidth: 150
      }
    },
    grid: {
      padding: {
        left: 20,
        right: 20
      }
    },
    tooltip: {
      x: {
        formatter: (val, opts) => summaryData.top_impact_links[opts.dataPointIndex]?.title
      },
      y: {
        formatter: (val) => val
      }
    }
  };

  const chartSeries = [
    {
      name: "DA",
      data: summaryData.top_impact_links?.map(item => item.da) || []
    },
    {
      name: "PA",
      data: summaryData.top_impact_links?.map(item => item.pa) || []
    }
  ];

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Backlinks Report</title>
      </Helmet>
      {loading === true ? <Loader /> : null}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <Container maxWidth={false} className="dashboard-container">
        <Grid container spacing={2} style={{ marginBottom: '20px' }}>

          <Grid container spacing={3} xs={12} sm={12} md={12} justifyContent="center">
            {cardDatas.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={item.id}>
                <Commoncard
                  item={item}
                  nonclikable={true}
                />
              </Grid>
            ))}
          </Grid>

          <Grid item xs={12} md={4}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Historical Backlink Trend</Typography>
              <Chart
                type="area"
                height={250}
                series={[
                  {
                    name: "Count",
                    // data: [4, 5, 6, 6, 77]
                    data: summaryData.historical_backlink_trend.map(i => i.count)
                  }
                ]}
                options={{
                  chart: {
                    toolbar: { show: false }
                  },
                  colors: ["#ff601f"],
                  stroke: { curve: 'smooth', width: 3 },
                  fill: {
                    type: 'gradient',
                    gradient: {
                      shadeIntensity: 1,
                      opacityFrom: 0.4,
                      opacityTo: 0.1
                    }
                  },
                  xaxis: {
                    // categories: ['Apr 12', 'Apr 13', 'Apr 14', 'Apr 15', 'Apr 16'],
                    categories: summaryData.historical_backlink_trend.map(i =>
                      new Date(i.date).toLocaleDateString('en-IN', { month: 'short', day: 'numeric' })
                    ),
                    tickPlacement: 'on', // 🔥 important
                    labels: {
                      offsetX: 50 // 👈 manual adjustment
                    }
                  },
                  yaxis: {
                    min: 0,
                    max: function (max) {
                      return max === 0 ? 10 : Math.ceil(max * 1.2);
                    },
                    tickAmount: 4,
                  },
                  grid: {
                    padding: { left: 0, right: 0 }
                  }
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Authority Distribution</Typography>
              <Chart
                type="bar"
                height={250}
                series={[{
                  name: "Authority Distribution",
                  data: Object.values(summaryData.authority_distribution) || []
                }]}
                options={{
                  chart: { toolbar: { show: false } },
                  plotOptions: {
                    bar: {
                      horizontal: false,
                      columnWidth: '45%',
                      borderRadius: 4,
                      distributed: true, // 👈 IMPORTANT
                      dataLabels: { position: 'top' }
                    }
                  },
                  colors: ["#3f51b5", "#d97757", "#00C9A7", "#FF4D4F", '#ae36ee', '#c9d429'], // 👈 each bar gets color
                  dataLabels: {
                    enabled: true,
                    offsetY: -20,
                    style: { fontSize: '12px' }
                  },
                  xaxis: {
                    categories: Object.keys(summaryData.authority_distribution) || [],
                    position: 'bottom',
                    labels: {
                      offsetX: 50,
                      style: { fontSize: '11px' }
                    }
                  },
                  yaxis: {
                    title: { text: 'Count' },
                    labels: { formatter: (val) => Math.floor(val) }
                  },
                  noData: { text: "No Metric Data Available" }
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Top Impact Links</Typography>
              <Chart
                options={chartOptions}
                series={chartSeries}
                type="bar"
                height={250}
              />
            </Box>
          </Grid>

        </Grid>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                <DatagridComp className="datagrid_custom_scroll"
                  columns={columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={2}
                  columnFreezeWidth={[0]}
                  tableLoading={tableLoading}
                  handleModelPopUp={handleModelPopUp}
                  handleDownlodingCSV={handleDownlodingCSV}
                  handleDownlodingPDF={handleDownlodingPDF}
                  DownloadShowFile={true}
                  customFilter={true}
                  DownloadShowPDF={1}
                  DownloadShowCSV={2}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Dialog
        open={OpenModalJob}
        onClose={CloseModalJobTrigger}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter"
      >
        <DialogTitle className="keyword-dialog-header">
          {"Filter By"}
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="cnt_hdr_blw_wrap">
              <div>
                <div className="">
                  <div>
                    <span className="select_filter_text">Completed Date</span>
                    <Select
                      value={dEngineoption}
                      options={completedate}
                      placeholder="Select..."
                      labelField="completed_at"
                      valueField="id"
                      onChange={(values) => {
                        setSelectval(values);
                        SetdEngineoption(values);
                      }}
                      styles={customDropdownStyles()}
                      menuPortalTarget={document.body}
                    />
                  </div>
                </div>

                <div className="col">
                  <span className="text-error">{validationFiter}</span>
                </div>
              </div>

              <div style={{ marginTop: "12px" }}>
                <div>
                  <label>Follow Type:</label>
                </div>

                <div>
                  <Select
                    value={FollowType}
                    options={[
                      { value: "all", label: "All" },
                      { value: "follow", label: "Follow" },
                      { value: "nofollow", label: "No Follow" },
                    ]}
                    placeholder="Select..."
                    defaultValue={{ value: "all", label: "All" }}
                    onChange={(e) => {
                      SetFollowType(e);
                      SetFollowTypeErr("");
                    }}
                    styles={customDropdownStyles()}
                    menuPortalTarget={document.body}
                  />
                </div>

                <div className="col">
                  <span className="text-error">{followTypeErr}</span>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>

        <DialogActions className="dialog-action-button">
          <button
            className="keyword-submit"
            onClick={TriggerFilter}
          >
            Submit
          </button>

          <button className="keyword-cancel" onClick={CloseModalJobTrigger}>
            Close
          </button>

          <button className="keyword-cancel" onClick={handleFilterReset}>
            Reset
          </button>
        </DialogActions>
      </Dialog>

      {/* 
      <DatagridComp
        columns={columns}
        rows={rows}
        autoheightval={autoheightval}
        datagridval={2}
        columnFreezeWidth={[0, 400]}
        tableLoading={tableLoading}
      /> */}
      {!openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />
      }

      <div className="">
        <Dialog
          open={selectedSuggesRow.openModel}
          onClose={closeSuggestion}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          style={{ alignItems: 'flex-start' }}
        >
          <DialogTitle className="keyword-dialog-header">Get Suggestion</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div>
                <form className="frm_container">
                  <div className="campaigns-addedit-row">
                    <div className="keyword-col1-fields">
                      <div>
                        <label for="city">
                          Target Keyword :
                        </label>
                        <input
                          type="text"
                          className="campaign-name"
                          value={selectedTargetKeyword}
                          onChange={(e) => { setSelectedTargetKeyword(e.target.value) }}
                          placeholder="Target Keyword"
                        />
                      </div>
                      <div>
                        <span className="error-value">{selectedTargetKeyword ? '' : 'This field is required'}</span>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="">
            <div className="dialog-action-button">

              <button className="keyword-submit" onClick={handleAiReadinessClick}>
                Submit
              </button>
              <button className="keyword-cancel" onClick={closeSuggestion}>
                Close
              </button>

            </div>
          </DialogActions>
        </Dialog>
      </div>
      <UserActivityTracker pagename="Backlinks - Backlinks Report" />
    </>
  );
}
